module.exports = __webpack_public_path__ + "img/portfolio_12.0146e658.jpg";